<template>
  <div class="my-3">
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScenarioPanel",
  props: {
    scenario: {
      type: Object,
      required: true
    }
  }
};
</script>
